export default __webpack_public_path__ + "static/QA-apresentacao-54b6547d2ad5d34b125d7fe8e30ec877.png";